import React, { FC } from 'react';

interface Props {
  text: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
}

const BlockHello: FC<Props> = ({ text, className }) => {
  return (
    <>
      <div className={`block-link ${className}`}>{text}</div>
    </>
  );
};

export default BlockHello;
